module.exports = __webpack_public_path__ + "img/programming.0e583de6.jpg";